import { useEffect, useState, useCallback } from "react";
import { getVendorById } from "../../api/adminApi";

import {
  Paper,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  Chip
} from "@mui/material";

export default function VendorInfo({ vendorId }) {
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchVendor = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getVendorById(vendorId);
      setVendor(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load vendor");
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    fetchVendor();
  }, [fetchVendor]);

  if (loading) return <CircularProgress />;
  if (!vendor) return <Typography>No data</Typography>;

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Vendor Details
      </Typography>

      <Table>
        <TableBody>

          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>{vendor.id}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>{vendor.name}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>{vendor.email || "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Location</TableCell>
            <TableCell>{vendor.location || "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Latitude</TableCell>
            <TableCell>{vendor.lat}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Longitude</TableCell>
            <TableCell>{vendor.lng}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>City</TableCell>
            <TableCell>{vendor.city}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Zone</TableCell>
            <TableCell>{vendor.zone}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>
              <Chip
                label={vendor.is_active ? "Active" : "Inactive"}
                color={vendor.is_active ? "success" : "default"}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell>Kitchen</TableCell>
            <TableCell>
              <Chip
                label={vendor.is_open ? "OPEN" : "CLOSED"}
                color={vendor.is_open ? "success" : "error"}
              />
            </TableCell>
          </TableRow>

        </TableBody>
      </Table>
    </Paper>
  );
}